export const AlternativeRowType = {
  Extra: 'extra',
  Unit: 'unit',
  UnitCustom: 'custom',
} as const;

export type AlternativeRowType = typeof AlternativeRowType[keyof typeof AlternativeRowType];
